import React from 'react'

import Tree from 'components/Tree'
import Project from './Project'
import Floor from './Floor'
import Room from './Room'

const ProjectTree = ({ cardsInRow, ...props }) => {
	return(
		<Tree
			{...props}
			NodeComponent={nodeProps => {
				const { nodeData, children } = nodeProps
				switch (nodeData.__typename) {
					case 'Project':
						return (
							<Project
								cardsInRow={cardsInRow}
								id={nodeData.id}
								{...nodeProps}
							/>
						)
					case 'Floor':
						return (
							<Floor {...nodeProps}/>
						)
					case 'Room':
						return (
							<Room
								floorId={nodeData.floorId}
								id={nodeData.id}
								{...nodeProps}
							/>
						)
					default:
						return children
				}
			}}
		/>
	)
}

export default ProjectTree
